import { isEnumKey } from "@faire/web--source/common/typescriptUtils";
import { useQueryParams } from "@faire/web--source/ui/hooks/useQueryParams";
import { ISearchRequestReferrer } from "@faire/web-api--source/indigofair/data/ISearchRequestReferrer";
import { QueryParameters } from "@faire/web-api--source/routes/category/c1CategoryUrlId";
import { useMemo } from "react";

import SearchRequestReferrerType = ISearchRequestReferrer.SearchRequestReferrerType;

export const useRequestReferrer = (): ISearchRequestReferrer => {
  const { refType = "NONE", refReqId } = useQueryParams(QueryParameters.parse);

  return useMemo(() => {
    const validRefType = isEnumKey(SearchRequestReferrerType, refType)
      ? refType
      : "NONE";

    return ISearchRequestReferrer.build({
      referrer_type: SearchRequestReferrerType[validRefType],
      referrer_request_id: refReqId,
    });
  }, [refReqId, refType]);
};
